module.exports = __webpack_public_path__ + "img/social-icon-fb-white.a91789a7.svg";